module.exports = __webpack_public_path__ + "img/menu-Edit.4185a9c0.svg";